import React from "react";
import "./ai-development-content.component.scoped.scss";
import { Box } from "@material-ui/core";
import { icons } from "../../../../../statics/icons";
import { useTranslation } from "react-i18next";
import CasesContent from "../cases-content/cases-content.component";
import { CASES_PAGE_TYPES } from "../../../types/AI-roles";
import { ContentLayout } from "../../../../../layouts/content/content.layout";
import PagesHeadComponent from "../../../../../components/pages-head-component/pages-head.component";

const AIDevelopmentContentComponent = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.AI_SOFTWARE_DEVELOPMENT_TITLE")}
          subTitle={t("PAGES_HEAD.AI_SOFTWARE_DEVELOPMENT_SUB_TITLE")}
          logo={icons.PAGES.HEAD.AI_PRODUCTS}
        />
        <CasesContent casesPageType={CASES_PAGE_TYPES.DEVELPMENT} />
      </ContentLayout>
    </Box>
  );
};

export default AIDevelopmentContentComponent;
